import {MvsCoreService} from "../../../../../../../../core/shared/service/mvs-core.service";
import {MvsCrudService} from "../../../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {AppointmentTypeService} from "../../../../../../service/api/appointment-type.service";
import {AppointmentTypeDto} from "../../../../../../model/dto/entity/appointment-type.dto";
import {AppointmentTypeAgentDto} from "../../../../../../model/dto/entity/appointment-type-agent.dto";
import {AgentDto} from "../../../../../../../../feature-core/am/model/dto/entity/agent.dto";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../../../../core/shared/dto/object/request/object-request-list";

@Component({
    selector: 'as-appointment-booking',
    templateUrl: 'appointment-booking.component.html',
    standalone: false
})
export class AppointmentBookingComponent implements OnInit, OnChanges, OnDestroy {

    appointmentTypeAgentService: MvsCrudService;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() customerId: number;

    appointmentTypeList: AppointmentTypeDto[];
    selectedAppointmentType: AppointmentTypeDto;

    appointmentTypeAgentList: AppointmentTypeAgentDto[];
    selectedAppointmentTypeAgent: AppointmentTypeAgentDto[];

    agents: AgentDto[];
    selectedAgents: AgentDto[];

    constructor(
        protected coreService: MvsCoreService,
        protected appointmentTypeService: AppointmentTypeService) {
        this.appointmentTypeAgentService = this.coreService.getCrudService("as.AppointmentTypeAgent");

    }

    ngOnInit(): void {

        const agents:any = [{id:157, name: 'marko'}, {id:2, name: 'carlo'}];
        this.selectedAgents = agents;

        this.agents = agents;

        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.retrieveAppointmentType();
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    retrieveAppointmentType() {

        if (this.busy) {
            return;
        }

        this.busy = true;

        this.appointmentTypeService.list(ObjectRequestList.createBasic(false, [], [])).subscribe(res => {
            this.appointmentTypeList = res.entries;
            this.busy = false;
        }, error => {
            this.appointmentTypeList = null;
            this.selectedAppointmentType = null;
            this.busy = false;
        });
    }

    retrieveAppointmentTypeAgent() {

        if (this.busy) {
            return;
        }

        this.busy = true;

        const filterCriteria = FilterCriteria.create('appointmentType', FilterCriteria.cOperatorEqual, this.selectedAppointmentType.id);

        this.appointmentTypeAgentService.list(ObjectRequestList.createBasic(false, [filterCriteria], [])).subscribe(res => {
            this.appointmentTypeAgentList = res.entries;
            this.busy = false;
        }, error => {
            this.appointmentTypeAgentList = null;
            this.selectedAppointmentTypeAgent = null;
            this.busy = false;
        });
    }

    handleSelect() {
        this.retrieveAppointmentTypeAgent();
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
